export const getDisplayMode = (env = globalThis) => {
  const { document, navigator, window } = env

  if (document?.referrer && document.referrer.startsWith('android-app://')) {
    return 'twa'
  }

  if (!!navigator && 'standalone' in navigator && navigator.standalone) {
    return 'standalone'
  }

  if (window?.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
    return 'standalone'
  }

  return 'browser'
}

export const resolvePwaSrc = ({ search, displayMode }) => {
  if (new URLSearchParams(String(search ?? '').split('#')[0]).get('src') === 'pwa') return 'pwa'
  if (displayMode === 'standalone' || displayMode === 'twa') return displayMode
  return null
}

// cookies 全面封鎖的環境連「讀取 window.sessionStorage 屬性」都會拋 SecurityError,
// 必須在取得參考時就防護,否則會炸掉整個 plugin 初始化
export const safeWindowStorage = (getStorage) => {
  try {
    return getStorage()
  } catch {
    return null
  }
}

const PWA_OPEN_SESSION_FLAG = 'pwa_open_sent'
const PWA_FIRST_OPEN_FLAG = 'pwa_first_open_sent'

export const createPwaOpenCapture = ({ push, src, launchAttribution, sessionStorage, localStorage }) => {
  const safeGetItem = (storageObj, key) => {
    try {
      return storageObj.getItem(key)
    } catch {
      return null
    }
  }

  return () => {
    if (safeGetItem(sessionStorage, PWA_OPEN_SESSION_FLAG)) return

    const base = {
      src,
      vendor: launchAttribution.vendorCode,
      trace_id: launchAttribution.traceId,
    }
    const opts = { conversionAttribution: launchAttribution }

    // first_open 隔離 try/catch:write-first 寧漏不發,且其例外不可拖累 pwa_open
    try {
      if (!safeGetItem(localStorage, PWA_FIRST_OPEN_FLAG)) {
        localStorage.setItem(PWA_FIRST_OPEN_FLAG, '1')
        push({ event: 'pwa_first_open', ...base }, null, opts)
      }
    } catch {
      // 靜默:寫旗標失敗或 tracker 例外都不阻擋 pwa_open
    }

    try {
      try {
        sessionStorage.setItem(PWA_OPEN_SESSION_FLAG, '1')
      } catch {
        // storage 禁用:去重旗標寫不進去 → 退化為不去重,事件照發
      }
      push({ event: 'pwa_open', ...base }, null, opts)
    } catch {
      // 靜默:背景追蹤不阻擋 UX
    }
  }
}

const IDLE_TIMEOUT_MS = 3000
const IDLE_FALLBACK_DELAY_MS = 1500

export const scheduleIdle = (fn, win = globalThis) => {
  if (typeof win.requestIdleCallback === 'function') {
    win.requestIdleCallback(fn, { timeout: IDLE_TIMEOUT_MS })
  } else {
    win.setTimeout(fn, IDLE_FALLBACK_DELAY_MS)
  }
}
